export default function validation(response, messages) {
  if (!response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('CUSTOMER_COUNTRY_REQUIRED') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'transmission.validation.customerCountryRequired',
        parametres: {
          client: elements[1],
          codes: elements[2],
        },
      });
    }
    if (message.indexOf('CUSTOMER_SIRET_REQUIRED') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'transmission.validation.customerSiretRequired',
        parametres: {
          client: elements[1],
          codes: elements[2],
        },
      });
    }
    if (message.indexOf('ALREADY_TRANSFERRED') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'transmission.validation.alreadyTransferred',
        parametres: {
          code: elements[1],
        },
      });
    }
    if (message.indexOf('CUSTOMER_ZIP_CODE_REQUIRED') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'transmission.validation.customerZipCodeRequired',
        parametres: {
          client: elements[1],
          codes: elements[2],
        },
      });
    }
    if (message.indexOf('INCORRECT_CUSTOMER_COUNTRY') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'transmission.validation.incorrectCustomerCountry',
        parametres: {
          client: elements[1],
          codes: elements[2],
          contry: elements[3],
        },
      });
    }
    if (message.indexOf('INCORRECT_PAYMENT_TYPE') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'transmission.validation.incorrectPaymentType',
        parametres: {
          modeReglement: elements[1],
          codes: elements[2],
        },
      });
    }
    if (message.indexOf('ORDER_REQUIRED') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'transmission.validation.orderRequired',
        parametres: {
          code: elements[1],
        },
      });
    }
    if (message.indexOf('PAYMENT_TYPE_REQUIRED') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'transmission.validation.paymentTypeRequired',
        parametres: {
          numEcheance: elements[2],
          code: elements[1],
        },
      });
    }
    if (message.indexOf('FACTOR_REQUIRED') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'transmission.validation.factorRequired',
        parametres: {
          codes: elements[1],
        },
      });
    }
    if (message.indexOf('ONLY_ONE_FACTOR_ALLOWED') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'transmission.validation.onlyOneFactorAllowed',
        parametres: {
          factors: elements[1],
        },
      });
    }
    if (message.indexOf('FORBIDDEN_TO_EXPORT_DOMTOM_AND_FR_CUSTOMERS_AT_ONCE') === 0) {
      messages.push({
        message: 'transmission.validation.forbiddenToExportDomTomAndFrCustomersAtOnce',
      });
    }
    if (message.indexOf('PAYMENT_TYPE_FACTOR_EXTERNAL_CODE_REQUIRE') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'transmission.validation.paymentTypeFactorExternalCodeRequired',
        parametres: {
          modeReglement: elements[1],
          codes: elements[2],
        },
      });
    }
    if (message.indexOf('CUSTOMER_ADDRESS_REQUIRED') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'transmission.validation.customerAdressRequired',
        parametres: {
          client: elements[1],
          codes: elements[2],
        },
      });
    }
    if (message.indexOf('CUSTOMER_ACCOUNTING_ACCOUNT_REQUIRED') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'transmission.validation.customerAccountingAccountRequired',
        parametres: {
          client: elements[1],
          codes: elements[2],
        },
      });
    }
  });
}
